const Paste = () => (
  <svg
    id="svg5"
    height="24"
    viewBox="0 0 32 32"
    width="24"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="layer1" transform="translate(-108 -484)">
      <path
        id="path21673"
        d="m113 488c-1.6447 0-3 1.3553-3 3v18c0 1.6447 1.3553 3 3 3h7.17773c-.11283-.31395-.17773-.64943-.17773-1v-14c0-1.6447 1.3553-3 3-3h6v-3c0-1.6447-1.3553-3-3-3h-1v2c0 1.0907-.9093 2-2 2h-7c-1.0907 0-2-.9093-2-2v-2zm3 0v2h7v-2z"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="4.1"
      />
      <g id="rect27399">
        <path
          id="path21678"
          d="m116 488v2h7v-2z"
          fill-rule="evenodd"
          stroke-linecap="round"
          stroke-linejoin="round"
          stroke-miterlimit="4.1"
          stroke-width="2"
        />
      </g>
      <path
        id="path21663"
        d="m125 496c-1.6447 0-3 1.3553-3 3v12c0 1.6447 1.3553 3 3 3h8c1.6447 0 3-1.3553 3-3v-12c0-1.6447-1.3553-3-3-3zm2 4h4c.55228 0 1 .44772 1 1s-.44772 1-1 1h-4c-.55229 0-1-.44772-1-1s.44771-1 1-1zm0 3h4c.55228 0 1 .44772 1 1s-.44772 1-1 1h-4c-.55229 0-1-.44772-1-1s.44771-1 1-1zm0 3h4c.55228 0 1 .44772 1 1s-.44772 1-1 1h-4c-.55229 0-1-.44772-1-1s.44771-1 1-1zm0 3h4c.55228 0 1 .44772 1 1s-.44772 1-1 1h-4c-.55229 0-1-.44772-1-1s.44771-1 1-1z"
        fill-rule="evenodd"
        stroke-linecap="round"
        stroke-linejoin="round"
        stroke-miterlimit="4.1"
      />
    </g>
  </svg>
);

export default Paste;
